import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import GranteeProfileInfo from '../../../widgets/granteeProfileInfo/GranteeProfileInfo'
import { getGranteeForStaff } from '../../../redux/actions/granteeForStaff'
import { startLoading, doneLoading } from '../../../utils/loading'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function granteeForStaff() {
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getGranteeForStaff(proposalId)
      console.log('res => ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log(e)
    }

    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load ObjectiveGoal proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <br />
          <GranteeProfileInfo schema={schema?.forms?.granteeProfile} />
          <br />
          {schema?.forms?.responsinatorProfile && (
            <>
              <GranteeProfileInfo schema={schema?.forms?.responsinatorProfile} />
              <br />
            </>
          )}
        </SidebarProposal>
      )}
    </>
  )
}
